'use client';

import { useEffect } from 'react';
import Link from 'next/link';

export default function Error({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  // Auto-retry once on mount (handles transient SSR failures)
  useEffect(() => {
    const retried = sessionStorage.getItem(`retry-${error.digest}`);
    if (!retried && error.digest) {
      sessionStorage.setItem(`retry-${error.digest}`, '1');
      reset();
    }
  }, [error.digest, reset]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center px-4">
      <div className="text-center max-w-md">
        <div className="text-6xl mb-4">⚠️</div>
        <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-3">
          This page didn&apos;t load correctly
        </h2>
        <p className="text-gray-600 dark:text-gray-400 mb-6">
          We hit a temporary issue loading this tool page. This usually resolves on refresh.
        </p>
        <div className="flex flex-wrap gap-3 justify-center">
          <button
            onClick={() => reset()}
            className="bg-emerald-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-emerald-700 transition"
          >
            Try again
          </button>
          <Link
            href="/tools"
            className="border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 px-6 py-3 rounded-lg font-semibold hover:bg-gray-100 dark:hover:bg-gray-800 transition"
          >
            Browse all tools
          </Link>
        </div>
      </div>
    </div>
  );
}
